import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Agent, AgentsService, ListComponent, PopUpService } from '../../core';
import { StoreService } from 'core/services/store.service';
import { AgentsListService } from '../services/agents-list.service';

@Component({
  selector: 'lms-agents-list',
  templateUrl: './agents-list.component.html',
  styleUrls: ['./agents-list.component.scss'],
  providers: [AgentsListService, AgentsService]
})
export class AgentsListComponent implements OnInit, OnChanges, OnDestroy {
  @Input() listId: string;
  @Input() options: any;

  @ViewChild(ListComponent, { static: false }) public listComponent: ListComponent;

  public dataSource: any;

  constructor(
    public agentsService: AgentsService,
    public agentsListService: AgentsListService,
    public router: Router,
    public translate: TranslateService,
    public popupService: PopUpService
  ) {}

  ngOnInit() {}

  async ngOnChanges() {
    this.dataSource = await this.agentsListService.getDatasource(this.listId, this.options);
  }

  public ngOnDestroy(): void {
    StoreService.remove(this.listId);
  }

  onClickRow(agent) {
    this.router.navigate(['/agents', agent.id]);
  }

  onDatasourceUpdate(dataSource) {
    this.dataSource = dataSource;
    StoreService.update(this.listId, this.dataSource);
  }

  delete(agent: Agent) {
    this.popupService
      .showConfirm({
        title: this.translate.instant('agents.confirmDelete', { agent: agent.name }),
        text: this.translate.instant('agents.deleteMessage')
      })
      .then(() => this.agentsService.delete(agent.id))
      .then(() => this.listComponent.fetch())
      .catch(() => {});
  }
}
